export const LINEAR_LOCATION_ROAD = "ROAD"
export const LINEAR_LOCATION_SECTION = "SECTION"